import * as types from './types';

export const sendGenericMessage = message => ({
  signalR: true,
  type: types.SIGNALR_RECEIVE_MESSAGE,
  payload: message,
});

export const invokeEvent = (event, payload = {}) => ({
  signalR: true,
  type: types.SIGNALR_INVOKE_MESSAGE,
  payload: {
    event: event,
    payload: payload,
  },
});

export const connect = () => ({
  signalR: true,
  type: types.SIGNALR_CONNECT,
});

export const reconnect = () => ({
  signalR: true,
  type: types.SIGNALR_RECONNECT,
});

export const connecting = () => ({
  signalR: true,
  type: types.SIGNALR_CONNECTING,
});

export const connectionFailed = message => ({
  signalR: true,
  type: types.SIGNALR_CONNECTION_FAILED,
  payload: message,
});

export const connected = () => ({
  signalR: true,
  type: types.SIGNALR_CONNECTED,
});

export const disconnect = () => ({
  signalR: true,
  type: types.SIGNALR_DISCONNECT,
});

export const disconnecting = () => ({
  signalR: true,
  type: types.SIGNALR_DISCONNECTING,
});

export const disconnected = () => ({
  signalR: true,
  type: types.SIGNALR_DISCONNECTED,
});

export const errored = message => ({
  signalR: true,
  type: types.SIGNALR_ERRORED,
  payload: message,
});

export const clearError = () => ({
  signalR: true,
  type: types.SIGNALR_ERRORED,
  payload: null,
});



// WEBPACK FOOTER //
// ./src/api/SignalR/state/actions.js